/* eslint-disable zeffo/no-window-storage */
import { PIP_IFRAME_SCROLL_POSITION_KEY } from '@core/pictureInPicture/keys'

/**
 * Lazy load restore PIP scroll
 */
export function restoreScrollLazy() {
  if (typeof window === 'undefined') {
    return
  }

  // Quick check on local storage and session storage to
  // avoid importing the module if not needed
  if (
    localStorage.getItem(PIP_IFRAME_SCROLL_POSITION_KEY) ||
    sessionStorage.getItem(PIP_IFRAME_SCROLL_POSITION_KEY)
  ) {
    import('./restoreScroll').then(({ restoreScroll }) => {
      restoreScroll()
    })
  }
}
